import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { ModalHeader, ModalBody } from '../modal-helpers';
import MediaItem from '../../components/MediaItem/MediaItem';
import { promotersInfo, PromoterInfo } from './constants';
import './AddPromoterModal.scss';

type OuterProps = {
  closeModal: () => any;
  onSelectPromoterType: (type: string) => void;
};

type HandlerProps = OuterProps & {
  promotersInfo: PromoterInfo[];
};

type OnSelectPromoter = (props: HandlerProps) => (index: number) => void;

type PropsFromWithState = {
  promotersInfo: PromoterInfo[];
};

type PropsFromWithHandlers = {
  onSelectPromoter: OnSelectPromoter;
};

type InnerProps = PropsFromWithState & PropsFromWithHandlers;

type HandleType = {
  onSelectPromoter: (index: number) => void;
};

type Props = OuterProps &
  PropsFromWithState &
  PropsFromWithHandlers &
  HandleType;

const onSelectPromoter: OnSelectPromoter =
  ({ onSelectPromoterType, promotersInfo, closeModal }) =>
  index => {
    const { type } = promotersInfo[index];

    onSelectPromoterType(type);
    closeModal();
  };

const enhance = compose<InnerProps, OuterProps>(
  withState('promotersInfo', 'setPromotersInfo', promotersInfo),
  withHandlers({ onSelectPromoter }),
);

const AddPromoterModal = (props: Props) => {
  const { onSelectPromoter, promotersInfo: items } = props;

  return (
    <div className="add-promoter-modal">
      <ModalHeader className="add-promoter-modal__header">
        Add HTML Element
      </ModalHeader>
      <ModalBody className="add-promoter-modal__body">
        {items.map(({ media, heading, description }, index) => (
          <div
            className="add-promoter-modal__item"
            key={index}
            onClick={() => onSelectPromoter(index)}
          >
            <MediaItem
              media={media}
              heading={heading}
              description={description}
            />
          </div>
        ))}
      </ModalBody>
    </div>
  );
};

export default enhance(AddPromoterModal);
